import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { loadApplicationByIdFailed, loadApplicationByIdSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* loadApplicationById(action) {
  try {
    const url = `${BACKEND_URL}/resources/applications/${action.payload}`;
    const dataResponse = yield makeRequest(url, {
      with_rejection_reasons: 1,
      with_trashed: 1,
      only_trashed: 1,
    }, action, 'GET', true);
    if (dataResponse.status === OK) {
      const data = yield dataResponse.json();
      yield put(loadApplicationByIdSuccessful(data.data));
      yield call(resolveActionPromise(action, data.data));
    } else {
      yield put(loadApplicationByIdFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(loadApplicationByIdFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
